/* eslint-disable no-template-curly-in-string */
import * as Yup from "yup";

const autoPluralize = function (word, num) {
  return num === 1 ? word : `${word}s`;
};

const isNullOrUndefined = function (value) {
  return value === null || value === undefined;
};

function minLowercase(length = 1, message) {
  const msg =
    message ||
    "${path} must contain at least ${length} lowercase " +
      autoPluralize("letter", length);
  return this.test({
    name: "minLowercase",
    exclusive: true,
    message: msg,
    params: { length },
    test(value) {
      return (
        isNullOrUndefined(value) ||
        (value.match(/[a-z]/g) || []).length >= length
      );
    },
  });
} // minLowercase()

function minUppercase(length = 1, message) {
  const msg =
    message ||
    "${path} must contain at least ${length} uppercase " +
      autoPluralize("letter", length);
  return this.test({
    name: "minUppercase",
    exclusive: true,
    message: msg,
    params: { length },
    test(value) {
      return (
        isNullOrUndefined(value) ||
        (value.match(/[A-Z]/g) || []).length >= length
      );
    },
  });
} // minUppercase()

function minNumbers(length = 1, message) {
  const msg =
    message ||
    "${path} must contain at least ${length} " +
      autoPluralize("number", length);
  return this.test({
    name: "minNumber",
    exclusive: true,
    message: msg,
    params: { length },
    test(value) {
      return (
        isNullOrUndefined(value) ||
        (value.match(/[0-9]/g) || []).length >= length
      );
    },
  });
} // minNumber()

function minSymbols(length = 1, message) {
  const msg =
    message ||
    "${path} must contain at least ${length} " +
      autoPluralize("symbol", length);

  return this.test({
    name: "minSymbol",
    exclusive: true,
    message: msg,
    params: { length },
    test(value) {
      return (
        isNullOrUndefined(value) ||
        (value.match(/[^a-zA-Z0-9\s]/g) || []).length >= length
      );
    },
  });
} // minSymbol()

export default function setup() {
  Yup.addMethod(Yup.string, "minLowercase", minLowercase);
  Yup.addMethod(Yup.string, "minUppercase", minUppercase);
  Yup.addMethod(Yup.string, "minNumbers", minNumbers);
  Yup.addMethod(Yup.string, "minSymbols", minSymbols);
}
